import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MaintenanceMode } from '@interfaces';
import { CMSService } from '@core';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  constructor(private readonly cms: CMSService) { }

  public isOutageDialogDisplayed = false;

  private getMaintenanceMode(): Observable<MaintenanceMode[]> {
    return this.cms.getMaintenanceMode();
  }


  public showOutagePopup(): Observable<{
    show: boolean;
    message: string;
    title?: string;
    is_complete_shutdown: boolean;
  }> {
    return this.getMaintenanceMode().pipe(
      map((res) => {
        const defaultResult = {
          show: false,
          message: '',
          title: '',
          is_complete_shutdown: false
        };

        try {
          if (!res || res.length === 0) return defaultResult;

          const config = res[0];
          const now = Date.now();

          const isInRange = (start?: string, end?: string): boolean => {
            if (!start || !end) return false;
            const s = new Date(start).valueOf();
            const e = new Date(end).valueOf();
            return now >= s && e >= now;
          };

          const isMaintenance = isInRange(config.start_date, config.end_date);

          // Case 1: display_flag AND shutdown-enabled AND shutdown settings present
          if (config.display_flag && config.is_complete_shutdown && config.complete_shutdown_settings) {
            const cs = config.complete_shutdown_settings;
            const isShutdown = isInRange(cs.start_date, cs.end_date);

            if (isShutdown) {
              return {
                show: true,
                message: cs.message_en,
                title: cs.title_en,
                is_complete_shutdown: true
              };
            }

            // If shutdown not active → check maintenance (fallback)
            if (isMaintenance) {
              return {
                show: true,
                message: config.message_en,
                title: config.title_en,
                is_complete_shutdown: false
              };
            }

            return defaultResult;
          }

          // Case 2: display_flag AND NOT shutdown mode
          if (config.display_flag && !config.is_complete_shutdown) {
            if (isMaintenance) {
              return {
                show: true,
                message: config.message_en,
                title: config.title_en,
                is_complete_shutdown: false
              };
            }

            return defaultResult;
          }

          // Case 3: Any other scenario → no popup
          return defaultResult;

        } catch (e) {
          return defaultResult;
        }
      }),
      catchError(() =>
        of({
          show: false,
          message: '',
          title: '',
          is_complete_shutdown: false
        })
      )
    );
  }

}
